export default "__VITE_ASSET__I16wt18k__"